// ══════════════════════════════════════════════════════════════
// COMPASS – Country Selectors
// ══════════════════════════════════════════════════════════════
import { createFeatureSelector, createSelector } from '@ngrx/store';
import { CountryState } from './country.state';
import { getCountryLabel } from '../../../shared/constants/country-codes';

export const selectCountryState = createFeatureSelector<CountryState>('country');

export const selectAllCountries = createSelector(
  selectCountryState,
  (state) => state.countries
);

export const selectCountriesLoading = createSelector(
  selectCountryState,
  (state) => state.loading
);

export const selectCountriesLoaded = createSelector(
  selectCountryState,
  (state) => state.loaded
);

/** Pre-built select options for grid columns: [{ label: "Portugal (PRT)", value: "PRT" }] */
export const selectCountrySelectOptions = createSelector(
  selectAllCountries,
  (countries) => countries.map(c => ({
    label: getCountryLabel(c.code ?? '', c.name),
    value: c.code as string,
  }))
);
